






































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import { zifuchuan, wenbenyu } from "./ziduans";
import Hover from "./hover.vue";
@Component({
  components: {
    Hover
  }
})
export default class ProjectThirdControlWenbenti extends Vue {
  @Prop()
  private ziduan: any;
  @Prop()
  private index: any;
  private defaultValue: any = "";
  private ifShowConfig: boolean = false;
  private temp: any = {
    content: {}
  };
  /**
   * @description 打开配置弹窗
   */
  private openConfigDialg() {
    this.temp = _.cloneDeep(this.ziduan);
    this.ifShowConfig = true;
  }
  /**
   * @description 切换类型
   */
  private toggleType(type) {
    switch (type) {
      case "字符串":
        this.$set(this.temp.content, "id", zifuchuan.id);
        this.$set(this.temp.content, "type", zifuchuan.type);
        this.$set(this.temp.content, "value", zifuchuan.value);
        break;
      case "文本域":
        this.$set(this.temp.content, "id", wenbenyu.id);
        this.$set(this.temp.content, "type", wenbenyu.type);
        this.$set(this.temp.content, "value", wenbenyu.value);
        break;
    }
  }
  /**
   * @description 保存
   */
  private save() {
    // 检查标题
    if (!this.temp.content.title) {
      this.$message.warning("标题不能为空");
      return;
    }
    this.$emit("ziduanChange", this.temp);
    this.ifShowConfig = false;
  }
  /**
   * @description 取消/关闭弹窗
   */
  private closeDialog() {
    this.temp = {};
    this.ifShowConfig = false;
  }
  /**
   * @description 删除这个字段
   */
  private deleteThis() {
    this.$emit("del");
  }
}
